import { useMemo } from 'react'

import { findQuotePositions } from '@/lib/assessment/quote-matching'

export function QuoteWithContext({ context, quotes }: { context: string; quotes: string[] }) {
  const positions = useMemo(() => findQuotePositions(quotes, context), [context, quotes])

  if (positions.length === 0) {
    return <div className='text-main-foreground-primary text-body-default'>...{context}...</div>
  }

  // Build segments
  const segments: React.ReactNode[] = []
  let cursor = 0

  for (let i = 0; i < positions.length; i++) {
    const { start, end } = positions[i]

    if (start > cursor) {
      const text = context.slice(cursor, start)
      segments.push(<span key={`pre-${i}`}>{cursor === 0 ? <>...{text}</> : text}</span>)
    } else if (cursor === 0) {
      segments.push(<span key={`ellipsis-${i}`}>...</span>)
    }

    segments.push(
      <mark key={`mark-${i}`} className='bg-marker-highlight'>
        {context.slice(start, end)}
      </mark>,
    )
    cursor = end
  }

  if (cursor < context.length) {
    segments.push(<span key='suffix'>{context.slice(cursor)}...</span>)
  }

  return <div className='text-main-foreground-primary text-body-default'>{segments}</div>
}
